import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { X, Save, Truck } from 'lucide-react';
import { updateOrderTicket } from '../../store/slices/despachoNacionalesSlice';
import './TicketModal.css';

const TicketModal = ({ order, onClose, temporadaId, semana }) => {
  const dispatch = useDispatch();
  const { updatingTicket } = useSelector((state) => state.despachoNacionales);
  const [ticketValue, setTicketValue] = useState('');
  const [error, setError] = useState('');

  const isUpdating = updatingTicket[order.id] || false;

  useEffect(() => {
    if (order.ticket_despacho) {
      setTicketValue(order.ticket_despacho);
    }
  }, [order]);

  const handleSave = async () => {
    setError('');

    if (!ticketValue.trim()) {
      setError('El número de ticket es requerido');
      return;
    }

    if (ticketValue.length > 100) {
      setError('El número de ticket no puede exceder 100 caracteres');
      return;
    }

    try {
      await dispatch(
        updateOrderTicket({
          orderId: order.id,
          ticketDespacho: ticketValue.trim()
        })
      ).unwrap();
      onClose();
    } catch (err) {
      setError(err || 'Error al actualizar ticket');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isUpdating) {
      handleSave();
    }
  };

  return (
    <div className="ticket-modal-overlay" onClick={onClose}>
      <div className="ticket-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ticket-modal-header">
          <div className="modal-title">
            <Truck size={24} />
            <h2>{order.ticket_despacho ? 'Editar Ticket de Despacho' : 'Ingresar Ticket de Despacho'}</h2>
          </div>
          <button className="btn-close" onClick={onClose} disabled={isUpdating}>
            <X size={20} />
          </button>
        </div>

        <div className="ticket-modal-body">
          <div className="order-info">
            <div className="info-row">
              <span className="info-label">Cliente:</span>
              <span className="info-value">{order.clientes?.nombre || 'Sin cliente'}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Temporada:</span>
              <span className="info-value">Semana {semana}</span>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="ticket-input">Número de Ticket de Despacho</label>
            <input
              id="ticket-input"
              type="text"
              className="ticket-input"
              value={ticketValue}
              onChange={(e) => setTicketValue(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ingrese el número de ticket"
              maxLength={100}
              disabled={isUpdating}
              autoFocus
            />
            <small className="input-hint">Máximo 100 caracteres</small>
          </div>

          {error && (
            <div className="ticket-modal-error">
              {error}
            </div>
          )}
        </div>

        <div className="ticket-modal-footer">
          <button
            className="btn-cancel"
            onClick={onClose}
            disabled={isUpdating}
          >
            Cancelar
          </button>
          <button
            className="btn-save"
            onClick={handleSave}
            disabled={isUpdating || !ticketValue.trim()}
          >
            <Save size={16} />
            {isUpdating ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketModal;
